// @flow weak

import React, {
  PureComponent
}                       from 'react';
import PropTypes        from 'prop-types';
import ViewLink         from './viewLink/ViewLink';
import MenuHeader     from '../menuHeader/MenuHeader';
import {
  Motion,
  spring
}                       from 'react-motion';
import { Link }         from 'react-router-dom';
import Menu       from './../Menu';
import Collapse       from 'react-collapse';
import cx               from 'classnames';

let isActive="";
import {aclUtil} from "../../../../../views/util"
// activeView: PropTypes.string.isRequired,
class MenuLinks extends PureComponent {
  constructor(props){
    super(props);
  }
  static propTypes = {
    activeView: PropTypes.string,
    views:      PropTypes.arrayOf(
      PropTypes.shape({
        name:       PropTypes.string.isRequired,
        linkTo:     PropTypes.string.isRequired,
        faIconName: PropTypes.string.isRequired,
        itemCount:  PropTypes.number,
        submMenu:   PropTypes.shape({
            id:     PropTypes.number.isRequired,
            group:  PropTypes.string.isRequired,
            menus:  PropTypes.arrayOf(
                      PropTypes.shape({
                        name:       PropTypes.string.isRequired,
                        linkTo:     PropTypes.string.isRequired,
                        linkKey:     PropTypes.string.isRequired,
                        faIconName: PropTypes.string.isRequired
                      })
                    )
          })
      })
    ).isRequired,
    initialCollapseState: PropTypes.bool
  };
  state = {
    isSubCollapsed: false,
    collapse:""
  };
  componentDidMount() {
    const { initialCollapseState } = this.props;
    if (!initialCollapseState) {
      this.setInitialCollapse(true);
    }
    if (typeof initialCollapseState === 'boolean') {
      this.setInitialCollapse(initialCollapseState);
    }
  }

  setInitialCollapse = (value) => {
    this.setState({ isSubCollapsed: value });
  }


  subMenuRender(submMenu){

    return submMenu.menus.map(
      ({name, linkTo, faIconName, linkKey, subMenu}, sidx) => {
        return (
          ((aclUtil.isPrimaryMenuAccessible(linkKey)) ?
            (linkTo !== '/') ?
            <li key={'mli'+sidx}><ViewLink
              key={sidx}
              linkTo={linkTo}
              linkKey={linkKey}
              viewName={name}
              faIconName={faIconName}
              backColor='#172D44'
            />
            </li>
            :
            <li key={'mli'+sidx}>
            <MenuHeader
              title={name}
              linkKey={linkKey}
              isCollapsed={!this.state.isSubCollapsed}
              backColor='#172D44'
              onClick={this.handlesCollapseFourthClick.bind(this, name)}
            />
            { (typeof subMenu !== 'undefined') &&
              <div className={name === this.state.fourthcollapse ? 'show':'hidden'}>
                <ul className="item-list-4" >{this.subMenuFourthRender(subMenu) }</ul>
              </div>
            }
            </li>
            : ''))
      })
  }
  handlesCollapseFourthClick = (name) => {
    const { isSubCollapsed,fourthcollapse } = this.state;
    this.setState({ isSubCollapsed: !isSubCollapsed });
    this.setState({ fourthcollapse: fourthcollapse === name ? null : name });
  }

  subMenuFourthRender(submMenu){
    return submMenu.menus.map(
      ({name, linkTo, faIconName, linkKey, subMenu}, sidx) => {
        return (
          ((aclUtil.isPrimaryMenuAccessible(linkKey)) ?
          <li key={'smli'+sidx}><ViewLink
          key={sidx}
          linkTo={linkTo}
          linkKey={linkKey}
          viewName={name}
          faIconName={faIconName}
          backColor='#172D44'
        /></li> : ''))
      })
  }

  handlesCollapseClick = (name)=> {
    //evt.preventDefault();
    const { isSubCollapsed,collapse } = this.state;
    this.setState({ isSubCollapsed: !isSubCollapsed });
    this.setState({ collapse: collapse === name ? null : name });
    
  }
  render() {
    const { isSubCollapsed,collapse } = this.state;
    const {
      activeView,
      views,
      backColor
    } = this.props;
    return (
      (views.length==1)?
        views.map(
          ({name, linkTo, faIconName, itemCount, linkKey, group}, idx) => {
            return ((aclUtil.isPrimaryMenuAccessible(linkKey)) ?
              <ViewLink
                key={idx}
                linkTo={linkTo}
                linkKey={linkKey}
                viewName={name}
                faIconName={faIconName}
                backColor='#172D44'
              />
            : '')
          }
        )
      :
      <ul className="item-list-2">
        { views.map(
            ({name, linkTo, faIconName, itemCount, submMenu, linkKey}, idx) => {
              if(submMenu) {
                return (
                  ((aclUtil.isPrimaryMenuAccessible(linkKey, 'parent')) ?
                  <li key={'smenu'+idx}>
                    <MenuHeader
                    title={name}
                    linkKey={linkKey}
                    isCollapsed={!isSubCollapsed}
                    backColor='#172D44'
                    onClick={this.handlesCollapseClick.bind(this,name)}
                  />
                    {/* <Collapse
                    isOpened={!isSubCollapsed}> */}
                    <div className={name===collapse?'show':'hidden'}>
                    <ul className="item-list-3" >{this.subMenuRender(submMenu) }</ul>
                    </div>
                  {/* </Collapse> */}
                  </li>
                  : '')
                );                      
              }else{
                return (
                  ((aclUtil.isPrimaryMenuAccessible(linkKey)) ?
                  <li key={'imenu'+idx}><ViewLink
                    key={idx}
                    isActive={activeView === name}
                    linkTo={linkTo}
                    linkKey={linkKey}
                    viewName={name}
                    faIconName={faIconName}
                    itemCount={itemCount ? itemCount : 0}
                    backColor={backColor}
                  /></li>
                  : '')
                )
              }
            }
          )
        }
      </ul>
    );
  }
}

export default MenuLinks;


// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/menu/menuLinks/MenuLinks.js